import React from 'react';

const Contact = () => (
  <div id="contact" className="space-medium">
    <div className="container">
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
          {/* section heading start */}
          <div className="section-heading">
            <h2 className="section-heading-title">Contact Us</h2>
            <p className="section-heading-text">
                Please complete the form to contact a Paladion sales representative
            </p>
            {/* section heading close */}
          </div>
        </div>
      </div>
      <div className="content pt-0">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 m-b-60">
              <div className="contact-section card-pattern-left card-pattern-right-top">
                <form method="post" action="/success" className="default-form" name="paladion-contact-us" data-netlify="true" data-netlify-honeypot="bot-field">
                  <input type="hidden" name="form-name" value="paladion-contact-us" />
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label htmlFor="name" className>
Name
                        <span className="text-danger">*</span>
                      </label>
                      <input type="text" name="Name" className="form-control" id="name" placeholder required />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="phone" className>
Phone
                        <span className="text-danger">*</span>
                      </label>
                      <input type="text" name="phone" className="form-control" id="phone" placeholder required />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="email" className>
Email
                        <span className="text-danger">*</span>
                      </label>
                      <input type="email" name="email" className="form-control" id="email" placeholder required />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="subject" className>
Subject
                        <span className="text-danger">*</span>
                      </label>
                      <input type="text" name="subject" className="form-control" id="subject" placeholder required />
                    </div>
                    <div className="form-group col-md-12">
                      <label htmlFor="message" className>Messages</label>
                      <textarea className="form-control" name="message" id="message" rows={4} placeholder defaultValue="" />
                    </div>
                  </div>
                  <input id="form_botcheck" name="form_botcheck" className="form-control" type="hidden" defaultValue />
                  <button type="submit" className="btn btn-brand btn-rounded" data-loading-text="Please wait...">Submit</button>
                </form>
                {/* contact form close */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Contact;
